export default {
  de: {
    add: 'Hinzufügen',
    add_to_calendar: 'Zum Kalender hinzufügen',
    address: 'Adresse',
    agenda: 'Agenda',
    archived_user_info: 'Archiviert (Login gesperrt und nicht mehr aufgeführt)',
    address_title: 'Titel (optional)',
    all: 'Alle',
    all_calendars: 'Alle Kalender',
    app_install: 'App Installieren',
    app_install_not: 'Nicht Installieren',
    app_install_howto: 'Um die App zu installieren, klicke jetzt auf "Installieren" und folge den Anweisungen.',
    app_install_howto_android: 'Um die App zu installieren, klicke oben rechts neben der Adresse auf das Menu (drei Punkte) und dann auf "Zum Startbildschirm hinzufügen".\nDanach kannst du dieses Fenster schliessen und die App vom Home Screen aus starten.',
    app_install_howto_ios: 'Um die App zu installieren, klicke unten auf "Teilen" (Pfeil nach oben) und dann auf "Zum Home-Bildschirm".\nDanach kannst du dieses Fenster schliessen und die App vom Home Screen aus starten.',
    app_install_done: 'Super, die App ist in wenigen Sekunden installiert. Du kannst dieses Fenster schliessen und die App vom Home Screen aus starten.',
    archived_show: 'Archivierte anzeigen',
    archived_hide: 'Archivierte verstecken',
    back: 'Zurück',
    birthday: 'Geburtstag',
    calendar: 'Kalender',
    calendar_edit: 'Kalender bearbeiten',
    calendar_new: 'Neuen Kalender erstellen',
    calendar_which: 'Kalender (leer = alle)',
    camera: 'Kamera',
    categories: 'Kategorien',
    category: 'Kategorie',
    category_choose: 'Kategorie / Kategorien wählen',
    category_categories: 'Kategorie / Kategorien',
    category_edit: 'Kategorie bearbeiten',
    category_empty_placeholder: 'leer = in allen Kategorien',
    category_new: 'Neue Kategorie erstellen',
    chat: 'Chat',
    chat_edit: 'Chat bearbeiten',
    chat_group: 'Chat Gruppe',
    chat_group_create: 'Chat Gruppe erstellen',
    chat_group_edit: 'Chat Gruppe bearbeiten',
    city: 'Ort',
    confirm_title: 'Bestätigung',
    confirm_ok: 'OK',
    confirm_cancel: 'Abbrechen',
    contact_save: 'Kontakt speichern',
    continue: 'Weiter',
    comments: 'Kommentare',
    comment_delete: 'Kommentar löschen',
    correct: 'Richtig',
    created: 'Erstellt',
    date: 'Datum',
    del: 'Löschen',
    description: 'Beschreibung',
    email: 'E-Mail',
    email_code_info: 'Du erhälst in Kürze eine E-Mail mit einem Bestätigungscode, gib diesen hier ein',
    email_reg_hint: 'Die E-Mail Adresse wird verifiziert',
    email_placeholders_hint: 'Die Platzhalter {EMAIL} und {PASSWORD} werden beim Versand ersetzt.',
    events: 'Events',
    eye_tooltip: 'für alle sichtbar? grün=ja, rot=nein',
    export_users: 'Export_Benutzer_',
    file: 'Datei',
    file_choose: 'Datei auswählen',
    files: 'Dateien',
    filter_groups: 'Filter: Gruppen',
    files_add: 'Dateien hinzufügen',
    folder_empty: 'Der Ordner ist leer',
    for_whom: 'Für wen (leer = nur an Alle)',
    forename: 'Vorname',
    gallery: 'Galerie',
    generate: 'Generieren',
    groups: 'Gruppen',
    group_members: 'Gruppen-Mitglieder',
    group_perms: 'Gruppen-Berechtigungen',
    groups_empty_placeholder: 'leer = für alle sichtbar',
    groups_visibility: 'Gruppen (nur sichtbar für..)',
    has_new: 'Zum Aktualisieren tippen',
    hidden_events: '1 versteckter Event | {n} versteckte Events',
    hidden_post: '1 versteckter Beitrag | {n} versteckte Beiträge',
    img: 'Bild',
    imgs_more: 'Weitere Bilder',
    invite: 'Einladen',
    item_deleted: 'Dieser Eintrag wurde gelöscht',
    lastname: 'Nachname',
    login_and_contact: 'Login & Kontakt',
    letsgo: 'Los geht\'s!',
    name: 'Name',
    mine: 'Meine',
    new: 'neu',
    no: 'Nein',
    notifications: 'Benachrichtigungen',
    notification_settings: 'Benachrichtigungseinstellungen',
    no_more_entries: 'Keine weiteren Beiträge',
    no_unread_notifications: 'Keine ungelesenen Benachrichtigungen',
    mark_as_read_all: 'Alle als gelesen markieren',
    mobile_nr: 'Mobile-Nr',
    mobile_code_info: 'Du erhälst in Kürze eine SMS mit einem Bestätigungscode, gib diesen hier ein',
    mobile_reg_hint: 'Die Mobile-Nr wird per SMS verifiziert.',
    months: 'Monat(e)',
    mute: 'Stumm schalten',
    from: 'Von',
    from_when: 'Ab wann',
    lastname: 'Nachname',
    mobile: 'Mobile',
    moderated: 'Moderiert',
    moderators: 'Moderatoren',
    to: 'Bis',
    color: 'Farbe',
    moderated: 'Moderiert',
    moderated_post: 'Moderiert (wird geprüft)',
    moderation_hint: 'Der Beitrag wird vor dem Publizieren überprüft.',
    objected: 'Markiert',
    password: 'Passwort',
    password_change: 'Passwort ändern',
    password_forgotten: 'Passwort vergessen',
    password_hint: 'Mind. 6 Zeichen',
    password_repeat: 'Passwort wiederholen',
    password_reset: 'Passwort zurücksetzen',
    passwords_not_matching: 'Passworte nicht identisch',
    person: 'Person',
    persons: 'Personen',
    player_url: 'URL zu MP3 Datei oder Youtube Video',
    player_file: 'Datei (mp3/pdf)',
    plz: 'PLZ',
    posts: 'Beiträge',
    post_delete: 'Beitrag löschen',
    post_foreign_warning: 'Du hast Themen gewählt, die Du selber nicht abonniert hast. Deshalb wirst du den Beitrag auch selber nicht sehen, solange du nicht mindestens eines dieser Themen abonnierst.',
    print: 'Drucken',
    print_tips: 'Tipps für\'s Drucken:<br>- Kopf- und Fusszeilen deaktivieren<br>- Hintergrundbilder aktivieren',
    profile_choose_img: 'Profilbild wählen',
    profile_name_hint: 'Der Name der überall angezeigt wird, kann auch ein Übername oder eine Abkürzung sein. Vorschlag: ',
    push_activate_q: 'Push Nachrichten aktivieren?',
    reactions: 'Reaktionen',
    recipient: 'Empfänger',
    registration_accept: 'Akzeptieren und Zugang zur App erlauben',
    registration_decline: 'Ablehnen und Zugang zur App verweigern',
    registration_requested: 'Login beantragt',
    remarks_internal: 'Bemerkungen (intern)',
    remove: 'Entfernen',
    reset_pw_mail_sent: 'Wir haben dir eine E-Mail zum setzen eines neuen Passworts gesendet. Nachdem du dort ein neues Passwort gewählt hast, kannst du dich hier damit anmelden.',
    save: 'Speichern',
    scheduled_post: 'Geplant',
    search: 'Suche',
    selfie: 'Selfie',
    sent: 'Versendet',
    settings: 'Einstellungen',
    sex: 'Geschlecht',
    sex_m: 'Männlich',
    sex_f: 'Weiblich',
    show: 'Anzeigen',
    show_more: 'Mehr',
    protected: 'Schreibgeschützt',
    ical_publish: 'Veröffentlichen (iCal)',
    ical_id: 'iCal ID: ',
    ical_save_hint: 'Speichern, um iCal ID anzuzeigen',
    signin: 'Anmelden',
    signout: 'Abmelden',
    signup: 'Registrieren',
    signup_moderation_hint: 'Vielen Dank für deine Anmeldung - sobald diese geprüft wurde, geht es hier weiter!',
    skip: 'Überspringen',
    sms_code: 'SMS Code',
    sms_code_info: 'Du erhälst innert wenigen Sekunden eine SMS mit einem 6-stelligen Zahlencode.',
    sms_code_hint: '6-stelliger Zahlencode',
    sort: 'Sortierung',
    source: 'Quelle',
    street: 'Strasse, Nr',
    subject: 'Betreff',
    subject: 'Betreff',
    subtitle: 'Untertitel',
    tags: 'Themen',
    tags_info: 'Es stehen neue Themen zur Auswahl',
    tags_subscribe: 'Abonniere alle Themen, die dich interessieren',
    tag: 'Thema',
    tags_choose: 'Thema / Themen wählen',
    tag_tags: 'Thema / Themen',
    tag_tags_which: 'Welche Themen (leer = alle)',
    tags_empty_placeholder: 'leer = an alle!',
    tel_g: 'Tel G',
    tel_p: 'Tel P',
    text: 'Text',
    text_intern: 'Text Intern',
    time: 'Zeit',
    title: 'Titel',
    telm: 'Tel Mobil',
    telp: 'Tel Privat',
    telw: 'Tel Geschäft',
    update_available: 'Ein Update ist verfügbar',
    updating: 'Update wird installiert..',
    url: 'URL',
    push: 'Push',
    price: 'Preis',
    attachments: 'Attachments',
    editorial: 'Editorial',
    users_pick: 'Person(en) wählen',
    users_export_sheet_all: 'ALLES',
    users_export_sheet_list: 'Liste',
    year_incl: 'Inkl. Jahr',
    yeargang: 'Jahrgang',
    yes: 'Ja',
    message_direct: 'Direktnachricht',
    message_group: 'Nachricht in Gruppenchat',
    new_post: 'Neuer Beitrag',
    new_post_review: 'Neuer Beitrag zur Prüfung',
    comment_my_post: 'Dein Beitrag wurde kommentiert',
    comment_my_comment: 'Ein Beitrag den du kommentiert hast wurde kommentiert',
    mention_me: 'Du wurdest erwähnt',
    signup_review: 'Neue Registration zur Prüfung',
    err_auth_email_already_in_use: 'Diese E-Mail Adresse wird bereits verwendet',
    err_auth_invalid_email: 'Die E-Mail Adresse ist ungültig',
    err_auth_invalid_phone_number: 'Die Mobile-Nr ist ungültig',
    err_auth_user_disabled: 'Konto deaktiviert',
    err_auth_user_not_found: 'Konto nicht gefunden',
    err_auth_wrong_password: 'Passwort ungültig',

    my_profile: 'Mein Profil',
    my_tags: 'Meine Themen',
    moderation: 'Moderation',
    printassistant: 'Druckassistent',
    newsletter: 'Newsletter',
    usersadmin: 'Benutzerverwaltung',
    groupsadmin: 'Gruppen',
    configuration: 'Konfiguration',
    wastebin: 'Papierkorb',
    area: 'Bereich',
    author: 'Autor',
    begin: 'Beginn',
    block: 'Blockieren',
    block_user: 'Benutzer blockieren',
    block_user_info: 'Wenn dir Beiträge dieses Benutzers nicht gefallen, kannst du ihn blockieren. Danach werden dir keine Beiträge mehr von ihm angezeigt.',
    created_date: 'Erstelldatum',
    release: 'Freigeben',
    restore: 'Wiederherstellen',
    shares: 'Ablagen',
    flagged_by: 'Markiert von',
    desc: 'Beschreibung',
    dislike: 'Gefällt mir nicht',
    dislike_info: 'Wenn dir ein Beitrag nicht gefällt, kannst du ihn ein für alle Mal ausblenden.',
    duplicate: 'Duplizieren',
    duplicate_dates: 'Daten wählen',
    end: 'Ende',
    flag_post: 'Beitrag melden',
    flag_post_info: 'Wenn ein Beitrag anstössig ist, kannst du ihn melden, damit er überprüft wird.',
    flag_post_hide: 'Beitrag ausblenden',
    hide_post: 'Ausblenden',
    location: 'Ort',
    limit: 'Limite',
    mute_chat: 'Chat stumm schalten',
    message: 'Nachricht',
    mobile: 'Mobile',
    no_registrations_yet: 'Noch keine Anmeldungen',
    participants: 'Teilnehmer',
    register: 'Anmelden',
    unregister: 'Abmelden',
    registered: 'Du bist angemeldet',
    event_fully_booked: 'Anlass ausgebucht :(',
    free_places_available: 'Es hat noch freie Plätze :)',
    report: 'Melden',
    reactions: 'Reaktionen',
    publication: 'Veröffentlichung',
    moderators: 'Moderatoren',
    protected: 'Schreibgeschützt',
    preview: 'Vorschau',
    result: 'Resultat',
    import: 'Importieren',
    export: 'Export',
    in_app: 'In App',
    import_done: 'Importieren abgeschlossen',
    import_file_tmpl: 'Import-Datei Vorlage',
    import_invalid_entries: 'Fehlerhafte Einträge (nicht importiert)',
    close: 'Schliessen',
    user: 'Benutzer',
    with_registration: 'Mit Anmeldung',
    registration_and_participants: 'Anmeldung und Teilnehmerliste',
    max_participants: 'Maximale Anzahl Teilnehmer (leer = unbegrenzt)',
    delete_post: 'Beitrag löschen?',
    recipients: 'Empfänger',
    birthdays: 'Geburtstage',
    subscription: 'Abo',
    topics: 'Themen',
    preview: 'Vorschau',
    send: 'Versenden',
    duplicate: 'Duplizieren',
    edit_chat: 'Chat bearbeiten',
    send_invitations: 'Einladungen versenden',
    administration: 'Administration',
  },
  fr: {
    all: 'Tous',
    all_calendars: 'Tous les calendriers',
    add: 'Ajouter',
    add_to_calendar: 'Ajouter au calendrier',
    address: 'Adresse',
    agenda: 'Agenda',
    archived_user_info: 'Archivé (connexion bloquée et plus répertorié)',
    address_title: 'Titre (optionnel)',
    app_install: 'Installer l\'application',
    app_install_not: 'Ne pas installer',
    app_install_howto: 'Pour installer l\'application, clique maintenant sur "Installer" et suis les instructions.',
    app_install_howto_android: 'Pour installer l\'application, clique sur le menu (trois points) en haut à droite de l\'adresse, puis sur "Ajouter à l\'écran d\'accueil".\nTu peux ensuite fermer cette fenêtre et lancer l\'application depuis l\'écran d\'accueil.',
    app_install_howto_ios: 'Pour installer l\'application, clique sur "Partager" (flèche vers le haut) en bas, puis sur "Vers l\'écran d\'accueil".\nTu peux ensuite fermer cette fenêtre et lancer l\'application depuis l\'écran d\'accueil.',
    app_install_done: 'Super, l\'application est installée en quelques secondes. Tu peux fermer cette fenêtre et lancer l\'app depuis l\'écran d\'accueil.',
    archived_show: 'Voir les archives',
    archived_hide: 'Masquer les archives',
    back: 'Retour',
    begin: 'Début',
    block: 'Bloquer',
    block_user: 'Bloquer l\'utilisateur',
    block_user_info: 'Si tu n\'aimes pas les messages de cet utilisateur, tu peux le bloquer. Tu ne verras alors plus aucun de ses messages.',
    birthday: 'Anniversaire',
    calendar: 'Calendrier',
    calendar_edit: 'Modifier le calendrier',
    calendar_new: 'Créer un nouveau calendrier',
    calendar_which: 'Calendrier (vide = tous)',
    camera: 'Appareil ?',
    categories: 'Catégories',
    category: 'Catégorie ',
    category_choose: 'Sélectionner les catégories',
    category_categories: 'Catégorie / Catégories',
    category_edit: 'Modifier la catégorie',
    category_empty_placeholder: 'Vide = Toutes les catégories',
    category_new: 'Créer une nouvelle catégorie',
    chat: 'Chat',
    chat_edit: 'Modifier le Chat',
    chat_group: 'Groupe Chat',
    chat_group_create: 'Créer un Chat groupe ',
    chat_group_edit: 'Modifier le Chat groupe',
    city: 'Lieu',
    confirm_title: 'Valider',
    confirm_ok: 'Ok',
    confirm_cancel: 'Annuler',
    contact_save: 'Enregistrer le contact',
    continue: 'Continuer',
    comments: 'Commentaires',
    comment_delete: 'Effacer le commentaire',
    correct: 'Correct',
    created: 'Créé',
    date: 'Date',
    del: 'Supprimer',
    description: 'Description',
    dislike: 'N\'aime pas',
    dislike_info: 'Si tu n\'aimes pas un message, tu peux le masquer définitivement.',
    duplicate: 'Dupliquer',
    duplicate_dates: 'Choisir les dates',
    email: 'E-Mail',
    email_code_info: 'Tu recevras bientôt un e-mail avec un code de confirmation, saisis-le ici',
    email_reg_hint: 'L\'adresse e-mail est vérifiée',
    email_placeholders_hint: 'Les espaces réservés {EMAIL} et {PASSWORD} seront remplacés lors de l\'envoi.',
    end: 'Fin',
    events: 'Événements',
    flag_post: 'Signaler le message',
    flag_post_info: 'Si un message est offensant, tu peux le signaler pour qu\'il soit vérifié.',
    flag_post_hide: 'Masquer le message',
    eye_tooltip: 'Visible pour tous ? vert=oui, rouge=non',
    file: 'Fichier',
    file_choose: 'Choisir un fichier',
    files: 'Fichiers',
    files_add: 'Ajouter des fichiers',
    filter_groups: 'Filtre: Groupes',
    folder_empty: 'Le dossier est vide',
    for_whom: 'Pour qui (vide = uniquement pour Tous)',
    forename: 'Prénom',
    gallery: 'Galerie',
    generate: 'Générer',
    groups: 'Groupes',
    group_members: 'Membres du groupe',
    group_perms: 'Permissions du groupe',
    groups_empty_placeholder: 'vide = visible pour tous',
    groups_visibility: 'Groupes (visible uniquement par..)',
    has_new: 'Cliquez pour actualiser',
    hidden_events: '1 événement vérifié | {n} événements vérifiés',
    hidden_post: '1 message caché | {n} messages cachés',
    hide_post: 'Masquer',
    img: 'Image',
    imgs_more: 'Plus d\'images',
    invite: 'Inviter',
    item_deleted: 'Cette entrée a été supprimée',
    lastname: 'Nom de famille',
    limit: 'Limite',
    location: 'Lieu',
    login_and_contact: 'Login & contact',
    letsgo: 'C\'est parti !',
    name: 'Nom',
    mine: 'Mes',
    new: 'nouveau',
    mute_chat: 'Mettre en sourdine',
    no_registrations_yet: 'Aucune inscription pour le moment',
    participants: 'Participants',
    register: 'S\'inscrire',
    unregister: 'Se désinscrire',
    registered: 'Tu es inscrit(e)',
    event_fully_booked: 'Événement complet :(',
    free_places_available: 'Il y a encore des places libres :)',
    no: 'Non',
    notifications: 'Notifications',
    notification_settings: 'Paramètres de notification',
    no_more_entries: 'Pas d\'autres messages',
    no_unread_notifications: 'Pas de notifications non lues',
    mark_as_read: 'Marquer comme lu',
    mark_as_read_all: 'Marquer tout comme lu',
    mobile_nr: 'Mobile-No',
    mobile_code_info: 'Tu recevras bientôt un SMS avec un code de confirmation, saisis-le ici',
    mobile_reg_hint: 'Le numéro de mobile est vérifié par SMS.',
    months: 'Mois',
    mute: 'Mettre en sourdine',
    from: 'De',
    from_when: 'À partir de quand',
    lastname: 'Nom de famille',
    mobile: 'Mobile',
    moderated: 'Modéré',
    moderators: 'Modérateurs',
    message: 'Message',
    to: 'À',
    color: 'Couleur',
    moderated: 'Modéré',
    moderated_post: 'Modération (en cours de vérification)',
    moderation_hint: 'La contribution est vérifiée avant d\'être publiée.',
    objected: 'Rejeté ?',
    password: 'Mot de passe',
    password_change: 'Modifier le mot de passe',
    password_forgotten: 'Mot de passe oublié',
    password_hint: 'Au moins 6 caractères',
    password_repeat: 'Confirmer le mot de passe',
    password_reset: 'Réinitialiser le mot de passe',
    passwords_not_matching: 'Les mots de passe ne sont pas identiques',
    person: 'Personne',
    persons: 'Personnes',
    player_url: 'URL du fichier MP3 ou de la vidéo Youtube',
    player_file: 'Fichier (mp3/pdf)',
    plz: 'Code Postal',
    posts: 'Messages',
    post_delete: 'Post supprimé',
    post_foreign_warning: 'Tu as choisi des sujets auxquels tu n\'es pas abonné(e). C\'est pourquoi tu ne verras pas le message tant que tu ne seras pas abonné à au moins un de ces sujets.',
    print: 'Imprimer',
    print_tips: 'Conseils pour l\'impression :<br>- Désactiver les en-têtes et pieds de page<br>- Activer les images d\'arrière-plan',
    profile_choose_img: 'Choisir une photo de profil',
    profile_name_hint: 'Le nom de ton profil peut être aussi un surmon ou une abréviation. Par exemple :',
    push: 'Push',
    push_activate_q: 'Activer les notifications push ?',
    recipient: 'Récepteur',
    registration_accept: 'Accepter et autoriser l\'accès à l\'app',
    registration_decline: 'Refuser et interdire l\'accès à l\'app',
    registration_requested: 'Connexion demandée',
    remarks_internal: 'Remarques (internes)',
    remove: 'Supprimer',
    report: 'Signaler',
    reactions: 'Réactions',
    publication: 'Publication',
    reset_pw_mail_sent: 'Nous t\'avons envoyé un e-mail pour que tu puisses définir un nouveau mot de passe. Après avoir choisi un nouveau mot de passe, tu peux t\'identifier ici.',
    reactions: 'Réactions',
    recipient: 'Destinataire',
    save: 'Enregistrer',
    scheduled_post: 'Planifié',
    search: 'Recherche',
    selfie: 'Selfie',
    sent: 'Envoyé',
    settings: 'Réglages',
    sex: 'Sexe',
    sex_m: 'Homme',
    sex_f: 'Femme',
    show: 'Afficher',
    show_more: 'Voir plus',
    protected: 'Protégé en écriture',
    ical_publish: 'Publier (iCal)',
    ical_id: 'ID iCal: ',
    ical_save_hint: 'Enregistrer pour afficher l\'ID iCal',
    signin: 'Connexion',
    signout: 'Déconnexion',
    signup: 'Inscription',
    signup_moderation_hint: 'Merci pour ton inscription - elle va être vérifiée!',
    skip: 'Sauter',
    sms_code: 'Code SMS',
    sms_code_info: 'Tu recevras en l\'espace de quelques secondes un SMS contenant un code numérique à 6 chiffres.',
    sms_code_hint: 'Code numérique à 6 chiffres',
    sort: 'Tri',
    source: 'Source ',
    street: 'Rue, numéro',
    subject: 'Sujet ',
    subtitle: 'Sous-titres',
    tags: 'Thèmes',
    tags_info: 'De nouveaux thèmes sont disponibles',
    tags_subscribe: 'Abonne-toi à tous les sujets qui t\'intéressent',
    tag: 'Thème',
    tags_choose: 'Choisir un thème',
    tag_tags: 'Thème/Thèmes',
    tag_tags_which: 'Quels thèmes (vide = tous)',
    tags_empty_placeholder: 'Vide = a tous',
    tel_g: 'Tél Prof',
    tel_p: 'Tél Privé',
    text: 'Texte',
    text_intern: 'Texte interne',
    time: 'Heure',
    title: 'Titre',
    telm: 'Tél mobile',
    telp: 'Tél Privé',
    telw: 'Tél Prof',
    update_available: 'Une mise à jour est disponible',
    updating: 'Mise à jour en cours d\'installation...',
    url: 'URL',
    push: 'Push',
    price: 'Prix',
    attachments: 'Pièces jointes',
    editorial: 'Éditorial',
    users_pick: 'Choisir une ou plusieurs personnes',
    users_export_sheet_all: 'TOUT',
    users_export_sheet_list: 'Liste',
    year_incl: 'Inclure l\'année',
    yeargang: 'Année de naissance',
    yes: 'Oui',
    message_direct: 'Message personnel ?',
    message_group: 'Message dans le chat group',
    new_post: 'Nouveau post',
    new_post_review: 'Nouveau post a valider',
    comment_my_post: 'Ton post a été commenté',
    comment_my_comment: 'Un post que tu as commenté a été commenté',
    mention_me: 'Tu as été mentionné',
    signup_review: 'Examen d\'une nouvelle inscritpion',
    err_auth_email_already_in_use: 'Cette adresse e-mail est déjà utilisée',
    err_auth_invalid_email: 'L\'adresse e-mail n\'est pas valable',
    err_auth_invalid_phone_number: 'Le numéro de mobile n\'est pas valable',
    err_auth_user_disabled: 'Compte désactivé',
    err_auth_user_not_found: 'Compte introuvable',
    err_auth_wrong_password: 'Mot de passe non valide',

    my_profile: 'Profil',
    my_tags: 'Sujets',
    moderation: 'Modération',
    printassistant: 'Assistant d\'impression',
    newsletter: 'Newsletter',
    usersadmin: 'Gestion des utilisateurs',
    groupsadmin: 'Groupes',
    configuration: 'Configuration',
    wastebin: 'Corbeille',
    area: 'Zone',
    author: 'Auteur',
    created_date: 'Date de création',
    release: 'Activer',
    restore: 'Restaurer',
    shares: 'Dépôts',
    flagged_by: 'Signalé par',
    desc: 'Description',
    moderators: 'Modérateurs',
    protected: 'Protégé',
    preview: 'Aperçu',
    result: 'Résultat',
    import: 'Importer',
    export: 'Export',
    in_app: 'Dans l\'app',
    import_done: 'Importation terminée',
    import_file_tmpl: 'Modèle de fichier d\'importation',
    import_invalid_entries: 'Entrées erronées (non importées)',
    close: 'Fermer',
    user: 'Utilisateur',
    with_registration: 'Avec inscription',
    registration_and_participants: 'Inscription et liste des participants',
    max_participants: 'Nombre maximum de participants (vide = illimité)',
    delete_post: 'Supprimer le message?',
    recipients: 'Destinataires',
    birthdays: 'Anniversaires',
    subscription: 'Abonnement',
    topics: 'Sujets',
    preview: 'Aperçu',
    send: 'Envoyer',
    duplicate: 'Dupliquer',
    edit_chat: 'Modifier le chat',
    send_invitations: 'Envoyer invitations',
    administration: 'Administration',
  },
}